import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	retry: {
		id: 'common.components.error-state.retry-action',
		defaultMessage: 'Try again',
		description: 'Text shown on a button that will retry a failed operation when clicked.',
	},
});
